import React, { FC, useState } from 'react';
import { formatDate } from 'utils/format';
import { useTranslation } from 'react-i18next';
import { Box, Grid, Typography } from '@mui/material';
import FormattedAddress from 'components/shared/address/formatted-address.component';
import { DeliveryTime } from 'models/order-input/shared';
import { Organization } from 'models/organization';

type DeliverySummaryProps = {
    deliveryDetails: {
        date: Date | null;
        time: DeliveryTime;
        pickUpLocation?: Organization;
        destination?: Organization;
    };
};
const DeliverySummary: FC<DeliverySummaryProps> = ({ deliveryDetails }) => {
    const { t: translate } = useTranslation(['common', 'orders']);
    const [time, setTime] = useState<{ hour: number | undefined; minute: number | undefined } | undefined>(
        deliveryDetails?.time,
    );

    return (
        <Grid container>
            <Grid item xs={12} md={3}>
                <Box mb={0.5}>
                    <Typography variant="subtitle2">{translate('orders:PICKUP_LOCATION')}</Typography>
                </Box>
                <Box>
                    <Box>{deliveryDetails.pickUpLocation?.name}</Box>
                    <Box>
                        <FormattedAddress hideCountry address={deliveryDetails.pickUpLocation?.contact?.address} />
                    </Box>
                </Box>
            </Grid>
            <Grid item xs={12} md={3}>
                <Box mb={0.5}>
                    <Typography variant="subtitle2">{translate('orders:DELIVERY_DESTINATION')}</Typography>
                </Box>
                <Box>
                    <Box>{deliveryDetails.destination?.name}</Box>
                    <Box>
                        <FormattedAddress hideCountry address={deliveryDetails.destination?.contact?.address} />
                    </Box>
                </Box>
            </Grid>
            <Grid item xs={12} md={3}>
                <Box mb={0.5}>
                    <Typography variant="subtitle2">{translate('orders:DELIVERY_DATE')}</Typography>
                </Box>
                <Box display="flex">
                    <Box>{formatDate(deliveryDetails.date || new Date(), 'date')}</Box>
                    {time?.hour || time?.hour === 0 ? (
                        <Box ml={1}>
                            {time.hour <= 9 ? '0' + time.hour : time.hour}:
                            {time?.minute ? (time.minute <= 9 ? '0' + time.minute : time.minute) : '00'}
                        </Box>
                    ) : undefined}
                </Box>
            </Grid>
        </Grid>
    );
};

export default DeliverySummary;
